<div class="fixed inset-0 z-[99999] bg-black/90" (click)="closeViewer()">
  <div
    class="relative w-full h-full flex items-center justify-center"
    (click)="$event.stopPropagation()"
  >
    <!-- Close Button -->
    <div class="absolute top-4 right-4 flex gap-3 z-[100000]">
      <button
        class="w-10 h-10 rounded-full bg-white flex items-center justify-center"
        (click)="closeViewer()"
      >
        ✕
      </button>
    </div>
    <!-- Thumbnails Top Center -->
    <div
      class="absolute top-4 left-1/2 -translate-x-1/2 flex gap-2 overflow-x-auto max-w-[90vw] z-[100000]"
    >
      @for (img of images; track $index) {
        <img
          [src]="img"
          (click)="selectImage($index)"
          class="w-16 h-16 rounded-lg object-cover cursor-pointer border-2 transition"
          [class.border-green-500]="currentIndex === $index"
          [class.border-transparent]="currentIndex !== $index"
          [class.opacity-60]="currentIndex !== $index"
        />
      }
    </div>

    <!-- Prev -->
    @if (images.length > 1) {
      <button
        class="absolute left-10 top-1/2 -translate-y-1/2 text-white text-6xl z-[100000]"
        (click)="prev()"
      >
        ‹
      </button>
    }

    <!-- Next -->
    @if (images.length > 1) {
      <button
        class="absolute right-10 top-1/2 -translate-y-1/2 text-white text-6xl z-[100000]"
        (click)="next()"
      >
        ›
      </button>
    }

    <!-- IMAGE FRAME -->
    <div
      class="relative w-[90vw] h-[70vh] max-w-[800px] max-h-[600px] rounded-2xl overflow-hidden bg-black shadow-2xl flex items-center justify-center touch-none select-none"
      (wheel)="onWheel($event)"
    >
      <img
        [src]="currentImage"
        class="w-full h-full object-cover cursor-grab active:cursor-grabbing transition-transform duration-150"
        [style.transform]="
          'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')'
        "
        (mousedown)="startDrag($event)"
        (mousemove)="onDrag($event)"
        (mouseup)="endDrag()"
        (mouseleave)="endDrag()"
        (touchstart)="startDrag($event)"
        (touchmove)="onDrag($event)"
        (touchend)="endDrag()"
      />
    </div>

    <!-- Zoom Controls -->
    <div
      class="absolute bottom-10 left-1/2 -translate-x-1/2 flex items-center justify-center gap-12 z-[100000] bg-black/50 backdrop-blur-md rounded-full px-6 py-2 shadow-lg"
    >
      <button (click)="zoomOut()" class="flex items-center justify-center">
        <mat-icon
          style="height: 30px; width: 24px; overflow: visible"
          class="text-white text-3xl cursor-pointer hover:text-green-400 transition-all duration-200"
        >
          zoom_out
        </mat-icon>
      </button>
      <button (click)="zoomIn()" class="flex items-center justify-center">
        <mat-icon
          style="height: 30px; width: 24px; overflow: visible"
          class="text-white text-3xl cursor-pointer hover:text-green-400 transition-all duration-200"
        >
          zoom_in
        </mat-icon>
      </button>
    </div>
  </div>
</div>
